<template>
  <div class="container-fluid h-100">
    <div class="container">
      <div class="row mt-5 pt-3">
        <div class="col-12">
          <h4 class="text-left text-dark font-weight-bold">
            Balance Zwapp: {{ this.totalBalance }}
          </h4>
        </div>
        <div class="col-4 mt-2">
          <input
            v-model="searchN"
            type="search"
            class="form-control"
            id="exampleFormControlInput1"
            placeholder="Buscar producto"
          />
        </div>
        <div class="col-1 mt-2">
          <button style="width:50px;" class="btn btn-danger btn-block" @click="search()">
            <i class="fa fa-search m-0 p-0" aria-hidden="true"></i>
          </button>
        </div>
        
        <div style="display:flex;" class="col-4 mt-2">
          <h6 style="margin:auto 10px auto auto;" class="text-dark font-weight-bold">
            Filtrar
          </h6>
          <select class="form-control" name="state" id="state" 
            v-model="typeId"
            v-on:change="searchType()"
          >
            <option value="null" disabled selected>Seleccione el tipo de producto</option>
            <option value="5">Bonos texaco</option>
            <option value="3">Accesorios de motos</option>
            <option value="6">Zwapp</option>
          </select>
        </div>
        <div class="col-3 mt-2">
          <button class="btn btn-info btn-block" @click="reset()">
            Nuevo producto
          </button>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-12">
          <div class="commentary">
            <span
              >El orden de los productos va según los puntos, de menor a
              mayor.</span
            >
          </div>
        </div>
      </div>

      <template v-if="loading.history">
        <div class="d-flex justify-content-center">
          <div
            class="spinner-border text-danger"
            style="width: 4em; height: 4rem;"
            role="status"
          ></div>
        </div>
      </template>

      <paginate
        v-else
        class="ul-pagination"
        name="items"
        :list="items"
        :per="9"
      >
        <div class="row mt-1">
          <div class="col-12">
            <div class="table-responsive">
              <table class="table table-striped table-sm">
                <thead>
                  <tr>
                    <th scope="col" style="text-align: left">Imagen</th>
                    <th scope="col" style="text-align: left">Nombre / sku</th>
                    <th scope="col" style="text-align: left">Descripción</th>
                    <th scope="col" style="text-align: left">Puntos</th>
                    <th scope="col" style="text-align: left">Precio</th>
                    <th scope="col" style="text-align: left">Estado</th>
                    <th scope="col" style="text-align: left">Acción</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, i) in paginated('items')"
                    :key="'d' + `item-${i}`"
                  >
                    <td style="text-align: left">
                      <img
                        width="100"
                        class="img-item"
                        :src="item.img"
                        :alt="item.name"
                      />
                    </td>
                    <td style="text-align: left">
                      {{ item.name }} <b> / {{ item.sku }} </b>
                      <span
                        class="badge bg-secondary text-white"
                        v-if="item.product_type_id == 6"
                      >
                        Zwapp</span
                      >
                    </td>
                    <td style="text-align: left">
                      {{ item.description }}
                    </td>
                    <td style="text-align: left">
                      <h6>
                        <span v-if="item.type_catalogue == 2" class="badge badge-pill badge-danger"
                          >Puntos:
                          {{ item.points_lub }}
                        </span>
                        <span v-else-if="item.type_catalogue == 3" class="badge badge-pill badge-danger"
                          >Puntos Motero:
                          {{ item.points }}&nbsp; - &nbsp;
                          Puntos Lubricador:
                          {{ item.points_lub }}
                        </span>
                        <span v-else class="badge badge-pill badge-danger"
                          >Puntos:
                          {{ item.points }}
                        </span>
                      </h6>
                    </td>
                    <td style="text-align: left">{{ item.price }}</td>
                    <td style="text-align: left">
                      <label v-if="item.status_id == 1" style="color: #dc3545">
                        {{ item.status.name }}
                      </label>
                      <label v-else style="color: gray">
                        {{ item.status.name }}
                      </label>
                    </td>
                    <td style="text-align: left">
                      <div class="btn-group" role="group">
                        <div class="btn-group" role="group">
                          <button
                            class="btn btn-info mt-0 pt-0 mb-0 pb-0 ml-2 pl-2 mr-2 pr-2"
                            title="Editar"
                            @click="edit(item)"
                          >
                            <i
                              class="fa fa-pencil m-0 p-0"
                              aria-hidden="true"
                            ></i>
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </paginate>

      <div class="row ">
        <div
          class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-12 mt-4 pl-md-5 pl-xl-2"
        >
          <label class="text-p"> Página {{ page }} de {{ totalPage }} </label>
        </div>
        <div
          class="col-12 col-md-9 col-lg-9 col-xl-9 col-sm-12 mt-4 center-paginate"
        >
          <paginate-links
            @change="pageChange"
            for="items"
            :limit="2"
            :show-step-links="true"
            :step-links="{ next: '>', prev: '<' }"
            :classes="{ ul: 'pagination', li: 'page-item', a: 'page-link' }"
          >
          </paginate-links>
        </div>
      </div>
    </div>

    <!-- Modal Nueva publicación -->
    <div
      class="modal fade"
      id="modalNewBanner"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered border-danger modal-xl">
        <div class="modal-content modal-question">
          <div class="modal-body">
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <i class="fa fa-times-circle text-danger" aria-hidden="true"></i>
            </button>
            <div class="mt-3 row justify-content-center">
              <div class="col-12 mb-3">
                <label style="color: #616161;"> <b> NUEVO PRODUCTO</b> </label
                ><br />
              </div>

              <!-- Estructura del formulario -->
              <div class="col-12  m-0 p-0">
                <div class="form-group">
                  <div class="row">
                    <div class="col-7">
                      <form ref="form" style="text-align: initial">
                        <label
                          for="image"
                          style="color: #616161; font-size: 14px"
                          ><b>Subir imagen *</b></label
                        ><br />
                        <input
                          type="file"
                          multiple
                          accept="image/*"
                          id="image"
                          name="image"
                          class="form-control-file mb-2"
                          style="color: black"
                          @change="onfileSelected($event)"
                          :class="{ 'is-danger': errorsFile || errorsFile2 }"
                        />
                        <span
                          v-if="errorsFile2"
                          class="text-danger small error-danger"
                          >{{ errorsFile2 }}</span
                        >
                        <span
                          v-if="errorsFile"
                          class="text-danger small error-danger"
                          >{{ errorsFile }}</span
                        ><br />
                      </form>
                      <div class="commentary">
                        <span
                          >RECOMENDACIÓN: solo se permiten imagenes en formato
                          (jpg,jpeg,png).
                        </span>
                        <span>El tamaño maximo de 1MB.</span><br />
                        <span
                          >Para dispositivos de escritorio el tamaño de la
                          imagen debe ser 250 x 250 pixeles.</span
                        >
                      </div>
                    </div>
                    <div class="col-5 m-0 p-0" style="text-align: end;">
                      <img
                        width="100"
                        v-for="(data, i) in listFile" :key="data.id"
                        :class="`img-h-${i}`"
                        style="background-color: rgba(198, 195, 195, 0.54);
                                            border-radius: 56px;"
                        src="../../../assets/img/Recurso 7.png"
                        alt="your image"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 m-0 p-0">
                <div class="form-group">
                  <div class="row" style="text-align: left">
                    <div class="col-7  m-0 p-0">
                      <div class="row">
                        <div class="col-12">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color: #616161; font-size: 14px"
                              ><b>Nombre *</b>
                            </label>
                            <input
                              :class="{ 'is-danger': errors.name }"
                              type="text"
                              v-model="form.name"
                              class="form-control"
                              placeholder="Escribe aquí el nombre del producto "
                            />
                          </div>
                          <span
                            v-if="errors.name"
                            class="text-danger float-left small error-danger mb-2"
                            >{{ errors.name }}</span
                          >
                        </div>
                        <div class="col-12">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color: #616161; font-size: 14px"
                              ><b>Estado del producto * </b>
                            </label>
                            <select
                              :class="{ 'is-danger': errors.status }"
                              class="form-control"
                              name="state"
                              id="state"
                              v-model="form.status"
                            >
                              <option value="null" disabled selected
                                >Seleccione el estado de producto</option
                              >
                              <option value="1">Activo</option>
                              <option value="2">Inactivo</option>
                            </select>
                          </div>
                          <span
                            v-if="errors.status"
                            class="text-danger float-left small error-danger mb-2"
                            >{{ errors.status }}</span
                          >
                        </div>
                        <div class="col-6">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color: #616161; font-size: 14px"
                              ><b>Puntos *</b>
                            </label>
                            <input
                              :class="{ 'is-danger': errors.points }"
                              type="number"
                              v-model="form.points"
                              class="form-control"
                              placeholder="Escribe aquí los puntos del producto"
                            />
                          </div>
                          <span
                            v-if="errors.points"
                            class="text-danger float-left small error-danger mb-2"
                            >{{ errors.points }}</span
                          >
                        </div>
                        <div class="col-6">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color: #616161; font-size: 14px"
                              ><b>Precio *</b>
                            </label>
                            <input
                              :class="{ 'is-danger': errors.price }"
                              type="number"
                              v-model="form.price"
                              class="form-control"
                              placeholder="Escribe aquí el precio del producto"
                            />
                          </div>
                          <span
                            v-if="errors.price"
                            class="text-danger float-left small error-danger mb-2"
                            >{{ errors.price }}</span
                          >
                        </div>
                      </div>
                    </div>
                    <div class="col-5 m-0 p-0">
                      <div class="form-group">
                        <label
                          class="ml-1"
                          for="state"
                          style="color: #616161; font-size: 14px"
                          ><b>Descripción del producto *</b>
                        </label>
                        <textarea
                          :class="{ 'is-danger': errors.description }"
                          rows="8"
                          type="text"
                          v-model="form.description"
                          class="form-control"
                          placeholder="Escribe aquí la descripción del producto"
                        />
                      </div>
                      <span
                        v-if="errors.description"
                        class="text-danger float-left small error-danger mb-2"
                        >{{ errors.description }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-10 col-md-5 col-lg-4 col-xl-4 col-sm-10 mt-3">
                <button
                  data-dismiss="modal"
                  type="button"
                  class="btn btn-secondary btn-sm btn-block button-login"
                >
                  Cancelar
                </button>
              </div>
              <div
                class="col-10 col-md-5 col-lg-4 col-xl-4 col-sm-10 mt-3 mb-3"
              >
                <button
                  @click="createPublication()"
                  type="button"
                  class="btn btn-danger btn-sm btn-block button-login"
                >
                  <template v-if="loading.changeDoc">
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Cargando...
                  </template>
                  <template v-else>Aceptar</template>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal Editar Banner -->
    <div
      class="modal fade "
      id="modalUpdateQuestion"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content modal-question ">
          <div class="modal-body">
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <i class="fa fa-times-circle text-danger" aria-hidden="true"></i>
            </button>
            <div class="mt-3 row justify-content-center">
              <div class="col-12 mb-3">
                <label style="color: #616161;">
                  <b> Editar publicación</b> </label
                ><br />
              </div>

              <!-- ESTRUCTURAS -->
              <div class="col-12  m-0 p-0">
                <div class="form-group">
                  <div class="row">
                    <div class="col-7">
                      <form ref="form" style="text-align: initial">
                        <label
                          for="image"
                          style="color: #616161; font-size: 14px"
                          ><b>Subir imagen *</b></label
                        ><br />
                        <input
                          type="file"
                          accept="image/*"
                          id="image"
                          name="image"
                          class="form-control-file"
                          style="color: black"
                          @change="onfileSelected($event)"
                          :class="{ 'is-danger': errorsFile || errorsFile2 }"
                        />

                        <span
                          v-if="errorsFile2"
                          class="text-danger small error-danger"
                          >{{ errorsFile2 }}</span
                        >
                        <span
                          v-if="errorsFile"
                          class="text-danger small error-danger"
                          >{{ errorsFile }}</span
                        ><br />
                      </form>
                      <div class="commentary">
                        <span
                          >RECOMENDACIÓN: solo se permiten imagenes en formato
                          (jpg,jpeg,png).
                        </span>
                        <span>El tamaño maximo de 1MB.</span><br />
                        <span
                          >Para dispositivos de escritorio el tamaño de la
                          imagen debe ser 250 x 250 pixeles.</span
                        >
                      </div>
                    </div>
                    <div class="col-5 m-0 p-0" style="text-align: end;">
                      <img
                        width="110"
                        class="imgH"
                        style="background-color: rgba(198, 195, 195, 0.54);
                                            border-radius: 56px;"
                        src="../../../assets/img/Recurso 7.png"
                        alt="your image"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 m-0 p-0">
                <div class="form-group">
                  <div class="row" style="text-align: left">
                    <div class="col-7  m-0 p-0">
                      <div class="row">
                        <div class="col-12">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color: #616161; font-size: 14px"
                              ><b>Nombre *</b>
                            </label>
                            <input
                              :class="{ 'is-danger': errors.name }"
                              type="text"
                              v-model="form.name"
                              class="form-control"
                              placeholder="Escribe aquí el nombre del producto "
                            />
                          </div>
                          <span
                            v-if="errors.name"
                            class="text-danger float-left small error-danger mb-2"
                            >{{ errors.name }}</span
                          >
                        </div>
                        <div class="col-12">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color: #616161; font-size: 14px"
                              ><b>Estado del producto * </b>
                            </label>
                            <select
                              :class="{ 'is-danger': errors.status }"
                              class="form-control"
                              name="state"
                              id="state"
                              v-model="form.status"
                            >
                              <option value="null" disabled selected
                                >Seleccione el estado de producto</option
                              >
                              <option value="1">Activo</option>
                              <option value="2">Inactivo</option>
                            </select>
                          </div>
                          <span
                            v-if="errors.status"
                            class="text-danger float-left small error-danger mb-2"
                            >{{ errors.status }}</span
                          >
                        </div>
                        <div class="col-6">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color: #616161; font-size: 14px"
                              ><b>Puntos *</b>
                            </label>
                            <input
                              :class="{ 'is-danger': errors.points }"
                              type="number"
                              v-model="form.points"
                              class="form-control"
                              placeholder="Escribe aquí los puntos del producto"
                            />
                          </div>
                          <span
                            v-if="errors.points"
                            class="text-danger float-left small error-danger mb-2"
                            >{{ errors.points }}</span
                          >
                        </div>
                        <div class="col-6">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color: #616161; font-size: 14px"
                              ><b>Precio *</b>
                            </label>
                            <input
                              :disabled="isWon"
                              :class="{ 'is-danger': errors.price }"
                              type="number"
                              v-model="form.price"
                              class="form-control"
                              placeholder="Escribe aquí el precio del producto"
                            />
                          </div>
                          <span
                            v-if="errors.price"
                            class="text-danger float-left small error-danger mb-2"
                            >{{ errors.price }}</span
                          >
                        </div>
                      </div>
                    </div>
                    <div class="col-5 m-0 p-0">
                      <div class="form-group">
                        <label
                          class="ml-1"
                          for="state"
                          style="color: #616161; font-size: 14px"
                          ><b>Descripción del producto *</b>
                        </label>
                        <textarea
                          :class="{ 'is-danger': errors.description }"
                          rows="8"
                          type="text"
                          v-model="form.description"
                          class="form-control"
                          placeholder="Escribe aquí la descripción del producto"
                        />
                      </div>
                      <span
                        v-if="errors.description"
                        class="text-danger float-left small error-danger mb-2"
                        >{{ errors.description }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-10 col-md-5 col-lg-4 col-xl-4 col-sm-10 mt-3">
                <button
                  data-dismiss="modal"
                  type="button"
                  class="btn btn-secondary btn-sm btn-block button-login"
                >
                  Cancelar
                </button>
              </div>
              <div
                class="col-10 col-md-5 col-lg-4 col-xl-4 col-sm-10 mt-3 mb-3"
              >
                <button
                  @click="updatePublication()"
                  type="button"
                  class="btn btn-danger btn-sm btn-block button-login"
                >
                  <template v-if="loading.changeDoc">
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Cargando...
                  </template>
                  <template v-else>Actualizar</template>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

export default {
  data() {
    return {
      listFile: [],
      searchN: "",
      errorsFile: false,
      errorsFile2: false,
      errorsTitle: false,
      errorsStatus: false,
      form: {
        id: 0,
        urlImg: "",
        name: "",
        status: null,
        points: null,
        price: null,
        description: "",
      },
      errors: {
        id: 0,
        urlImg: "",
        name: "",
        status: null,
        points: null,
        price: null,
        description: "",
      },
      typeId: null,
      currentForm: {},
      file: null,
      loading: {
        publicate: false,
        history: false,
        changeDoc: false,
        order: false,
      },
      hidden: {
        btn: false,
      },
      paginate: ["items"],
      page: 1,
      totalPage: 1,
      isWon: false,
      totalBalance: 0,
    };
  },
  methods: {
    onfileSelected(event) {
      let app = this;
      var fileSize = null;
      var extension = null;
      var url = null;
      this.listFile = [];
      if (event.target.files.length < 5) {
        for (let i = 0; i < event.target.files.length; i++) {
          fileSize = event.target.files[i].size;
          extension = event.target.files[i].name.split(".");
          if (fileSize > 1000000) {
            this.errorsFile = "El archivo no debe superar 1MB. ";
            return false;
          }
          if (
            extension[1] != "jpg" &&
            extension[1] != "png" &&
            extension[1] != "jpeg"
          ) {
            this.errorsFile2 = " La extensión es inválida. ";
            return false;
          } else {
            this.errorsFile = false;
            this.errorsFile2 = false;
            var reader = new FileReader();
            reader.readAsDataURL(event.target.files[i]);
            reader.onload = function(e) {
              url = e.target.result;
              $(".img-h-" + i).attr("src", e.target.result);
            };
            app.listFile.push({ file: event.target.files[i], url: url });
          }
        }
      } else {
        this.errorsFile = "No se pueden adjuntar más de 4 imágenes. ";
        return false;
      }
    },
    searchType() {
      this.items = [];
      this.loading.history = true;
      if (this.typeId != null) {
        axios
        .get("superAdmin/product/moto/type/" + this.typeId)
        .then((res) => {
          if (res.data.cod == 0) {
            // this.items = res.data.data;
            const dataTemp = res.data.data
            dataTemp.map((item) => {
              if(item.status_id != 10){
                this.items.push(item)
              }
            })
            this.totalPage = Math.ceil(parseInt(this.items.length) / 9);
          }
          this.loading.history = false;
        })
        .catch((error) => {
          this.loading.history = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message,
          });
        });
      }
    },
    search() {
      this.items = [];
      this.loading.history = true;
      if(this.searchN != ""){
        axios
        .get("superAdmin/product/moto/" + this.searchN)
        .then((res) => {
          if (res.data.cod == 0) {
            // this.items = res.data.data;
            const dataTemp = res.data.data
            dataTemp.map((item) => {
              if(item.status_id != 10){
                this.items.push(item)
              }
            })
            this.totalPage = Math.ceil(parseInt(this.items.length) / 9);
          }
          this.loading.history = false;
        })
        .catch((error) => {
          this.loading.history = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message,
          });
        });
      } else {
        alert("Ingrese algo para buscar");
        this.getProducts();
      }
    },
    validform() {
      let app = this;
      if (app.file == null) {
        app.errorsFile = "La imagen es requerida";
      }

      if (!this.form.name) {
        this.errors.name = "El nombre del producto es requerido.";
      }
      if (!this.form.description) {
        this.errors.description = "La descripción del producto es requerida.";
      }
      if (!this.form.points) {
        this.errors.points = "La cantidad de puntos es requerida.";
      }
      if (!this.form.price) {
        this.errors.price = "El precio del producto es requerido.";
      }
      if (!this.form.status) {
        this.errors.status = "El estado del producto es requerido.";
      }

      if (
        !app.errorsFile &&
        !app.errorsTitle &&
        !this.errors.name &&
        !this.errors.status &&
        !this.errors.description &&
        !this.errors.points &&
        !this.errors.price
      ) {
        return true;
      }

      return false;
    },
    validformEdit() {
      return true;
      // let app = this;
      // if (!app.form.title || !app.form.state) {
      //     app.errorsTitle = "Al menos un campo es requerido";
      // }
      // if (!app.errorsFile && !app.errorsTitle && !app.errorsStatus) {
      //     return true;
      // }
      // return false;
    },
    createPublication() {
      console.log("Holaaa");
      let app = this;
      if (this.validform()) {
        console.log("good");
        this.saveImg(app.file);
      }
    },
    updatePublication() {
      if (this.validformEdit()) {
        console.log("good update");
        this.postUpdate();
      }
    },
    reset() {
      this.$router.push({ name: "addAdminProducts" });
      // this.form.name = "";
      // this.form.status = null;
      // this.form.description = "";
      // this.form.points = null;
      // this.form.price = null;
      // this.errorsFile = false;
      // this.errorsTitle = false;
      // this.errorsStatus = false;
      // this.errorsFile2 = false;
      // this.$refs.form.reset();
      // this.file = null;
      // setTimeout(() => {
      //   this.errorsTitle = false;
      //   this.errorsFile = false;
      //   this.errors.name = false;
      //   this.errors.status = false;
      //   this.errors.description = false;
      //   this.errors.points = false;
      //   this.errors.price = false;
      // }, 0);
    },
    edit(data) {
      this.$router.push({ name: "editAdminProducts", params: { id: data.id } });

      // this.currentForm.name = data.name;
      // this.currentForm.status = data.status_id;
      // this.errorsFile = false;
      // this.errorsTitle = false;
      // this.errorsStatus = false;
      // this.errorsFile2 = false;
      // this.file = {};
      // this.form.id = data.id;
      // this.form.name = data.name;
      // this.form.status = data.status_id;
      // this.form.description = data.description;
      // this.form.points = data.points;
      // this.form.price = data.price;
      // this.form.urlImg = data.img;
      // if (data.checkWon == 1) {
      //   this.isWon = true;
      // } else {
      //   this.isWon = false;
      // }
      // $(".imgH").attr("src", data.img);
    },
    saveImg(file) {
      console.log(file);
      const formData = new FormData();

      for (let i = 0; i < this.listFile.length; i++) {
        formData.append("img[" + i + "]", this.listFile[i].file);
      }
      // formData.append("img", file);
      formData.append("name", this.form.name);
      formData.append("description", this.form.description);
      formData.append("status_id", this.form.status);
      formData.append("points", this.form.points);
      formData.append("price", this.form.price);
      this.loading.changeDoc = true;
      axios
        .post("superAdmin/product/moto", formData)
        .then((res) => {
          if (res.data.cod == 0) {
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "success",
              title: "Muy bien",
              text: res.data.message,
            });
            this.loading.changeDoc = false;
            $("#modalNewBanner").modal("hide");
            this.getProducts();
            this.getBalance();
          }
        })
        .catch((error) => {
          this.loading.changeDoc = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message,
          });
        });
    },
    postUpdate() {
      const formData = new FormData();
      if (this.currentForm.name != this.form.name) {
        formData.append("name", this.form.name);
      }
      formData.append("status_id", this.form.status);
      formData.append("points", this.form.points);
      formData.append("price", this.form.price);
      formData.append("description", this.form.description);

      console.log(this.form);

      if (this.file.size != undefined) {
        formData.append("img", this.file);
      }
      this.loading.changeDoc = true;
      axios
        .post("superAdmin/product/moto/" + this.form.id, formData)
        .then((res) => {
          console.log(res.data.data);
          if (res.data.cod == 0) {
            $("#modalUpdateQuestion").modal("hide");
            this.getProducts();
            this.getBalance();
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "success",
              title: "Muy bien",
              text: res.data.message,
            });
          }
          this.loading.changeDoc = false;
        })
        .catch((error) => {
          this.loading.changeDoc = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message,
          });
        });
    },
    getProducts() {
      this.items = [];
      this.loading.history = true;
      axios
        .get("superAdmin/product/moto")
        .then((res) => {
          console.log(res.data.data);
          if (res.data.cod == 0) {
            // this.items = res.data.data;
            const dataTemp = res.data.data
            dataTemp.map((item) => {
              if(item.status_id != 10){
                this.items.push(item)
              }
            })
            this.totalPage = Math.ceil(parseInt(this.items.length) / 9);
          }
          this.loading.history = false;
        })
        .catch((error) => {
          this.loading.history = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message,
          });
        });
    },
    getBalance() {
      axios
        .get("api/balance/get")
        .then((res) => {
          if (res.data.cod == 0) {
            this.totalBalance = res.data.data.balance;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    pageChange(toPage) {
      this.page = toPage;
    },
  },
  mounted() {
    this.pageChange(1);
    this.getProducts();
    this.getBalance();
  },
  watch: {
    searchN: function(newN) {
      if (!newN) {
        setTimeout(() => this.getProducts(), 15000);
      }
    },
    "form.name": function(newV) {
      if (!newV) {
        this.errors.name = "El nombre del producto es requerido.";
      } else {
        this.errors.name = false;
      }
    },
    "form.description": function(newV) {
      if (!newV) {
        this.errors.description = "La descripción del producto es requerida.";
      } else {
        this.errors.description = false;
      }
    },
    "form.points": function(newV) {
      if (!newV) {
        this.errors.points = "La cantidad de puntos es requerida.";
      } else {
        this.errors.points = false;
      }
    },
    "form.price": function(newV) {
      if (!newV) {
        this.errors.price = "El precio del producto es requerido.";
      } else {
        this.errors.price = false;
      }
    },
    "form.status": function(newV) {
      if (!newV) {
        this.errors.status = "El estado del producto es requerido.";
      } else {
        this.errors.status = false;
      }
    },
    "form.urlImg": function(newV) {
      if (!newV) {
        this.errors.urlImg = "La imagen del producto es requerida.";
      } else {
        this.errors.urlImg = false;
      }
    },
  },
};
</script>

<style>
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
  padding-right: 0px !important;
  padding-left: 0px !important;
  overflow: hidden;
}

.div-button {
  margin-top: 50px;
  text-align: left;
}

.is-danger {
  border: solid 2px !important;
  border-color: #e9434c !important;
}

.modal-title {
  color: black;
  font-weight: bold;
}

.modal-question {
  border: solid 3px;
  border-color: #dc3545;
  border-radius: 15px;
}

label {
  color: black;
  margin-right: 4px;
}

.img-banner {
  display: block;
  width: 25%;
  text-align: center;
  margin: auto;
}

td {
  text-align: center;
  vertical-align: -webkit-baseline-middle;
  cursor: all-scroll;
}

.table-container {
  overflow: auto;
}

h5 {
  margin-bottom: 10px !important;
}

.commentary {
  text-align: left;
  color: #1da5df;
  font-size: 13px;
}

.page-item.active .page-link {
  border-style: none;
  border-radius: 20px;
  background-color: #dc3545;
}

a.page-link {
  color: black;
  cursor: pointer;
}

a.page-link:hover {
  color: #dc3545;
}

.page-link {
  background-color: #f5f5dc00;
  border-radius: 20px;
  border-color: none;
}

.page-item.disabled .page-link {
  color: #dc3545;
  background-color: #fff0;
  border-color: #dee2e600;
}

.ul-pagination {
  padding: 0px;
}
</style>
